// src/routes/_org/org/portal/statistics.tsx
import { createFileRoute } from '@tanstack/react-router';

import { StatisticsPage } from '@/features/org-analytics/pages/StatisticsPage';

export const Route = createFileRoute('/_org/org/portal/statistics')({
  component: StatisticsPage,
});
